export function extractRedirectUrl(url: string): string {
  return new URL(url).hash.replace("#", "");
}
